export const actionTypes = {
    ADD_DRONE_IMAGE_FOR_UPLOAD: 'UPLOAD/ADD_DRONE_IMAGE_FOR_UPLOAD',
    CLEAR_DRONE_IMAGE_FOR_UPLOAD: 'UPLOAD/CLEAR_DRONE_IMAGE_FOR_UPLOAD',
    SET_DRONE_IMAGE_DISTORTION_TOOL: 'UPLOAD/SET_DRONE_IMAGE_DISTORTION_TOOL',
    SET_DRONE_IMAGE_OPACITY: 'UPLOAD/SET_DRONE_IMAGE_OPACITY',
    SET_DRONE_IMAGE_DISTORTION_CORNERS: 'UPLOAD/SET_DRONE_IMAGE_DISTORTION_CORNERS',

    SET_DRONE_IMAGE_MANUAL_POSITION: 'UPLOAD/SET_DRONE_IMAGE_MANUAL_POSITION',
};
